export default (pollId: string, uid: string): string => {
    return `poll/${pollId}/__voter/${uid}`;
};
